
export default {
  props: {
    price: {
      type: [Number, String],
      required: true,
    },
    originalPrice: {
      type: [Number, String],
      default: 0,
    },
    isFree: {
      type: Boolean,
    },
  },
  computed: {
    isFreeDeal() {
      return this.isFree || parseFloat(this.price) <= 0;
    },
  },
  methods: {
    parseDecimal(price) {
      return (parseFloat(price) % 1 !== 0) ? 2 : 0;
    },
  },
};
